import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  LicenseRef: { input: any; output: any; }
  PropertyRef: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

/** Listing origin. */
export enum ListingProvider {
  Airbnb = 'AIRBNB',
  Flipkey = 'FLIPKEY',
  Homeaway = 'HOMEAWAY',
  Tripadvisor = 'TRIPADVISOR',
  /**
   * Listing origin cannot be inferred, unknown or unsupported.
   *
   * List of providers may be extended without warning. Clients must handle values they do not support as UNKNOWN for
   * forward compatibility reasons. Clients must handle UNKNOWN.
   */
  Unknown = 'UNKNOWN',
  Vrbo = 'VRBO'
}

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Violation guid is unique globally across customers, no need to pass region id.
   * https://github.com/deckardtech/deckard-ariadne/blob/main/deckard-ariadne/chalicelib/schema/violations.graphql#L239
   */
  markActive: Scalars['Boolean']['output'];
  markIgnored: Scalars['Boolean']['output'];
  markSuspended: Scalars['Boolean']['output'];
  markUnderReview: Scalars['Boolean']['output'];
};


export type MutationMarkActiveArgs = {
  violationId: Scalars['ID']['input'];
};


export type MutationMarkIgnoredArgs = {
  violationId: Scalars['ID']['input'];
};


export type MutationMarkSuspendedArgs = {
  violationId: Scalars['ID']['input'];
};


export type MutationMarkUnderReviewArgs = {
  violationId: Scalars['ID']['input'];
};

/**
 * PageInfo type which conforms to Relay specs.
 * See https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  hello: Scalars['String']['output'];
  region?: Maybe<Region>;
};


export type QueryRegionArgs = {
  regionId: Scalars['ID']['input'];
};

export type Region = {
  __typename?: 'Region';
  /** Customer name, e.g. ca-placer. */
  name: Scalars['String']['output'];
  /**
   * Provides access to the filtered list of violations within the region.
   *
   * Violations are always returned in reverse chronological order (newest first) by the detection timestamp.
   *
   * If filter is not provided, all violations are returned (scoped to the current region).
   */
  violations: ViolationsConnection;
};


export type RegionViolationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ViolationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Generic violation record. */
export type Violation = {
  __typename?: 'Violation';
  /**
   * Active license (if any; offending property may not be licensed at all) associated with this violation (even if the
   * violation is not *caused* by the license).
   *
   * May be empty if property is unlicensed or does not have active licenses (for example, previous license is expired).
   *
   * May have more than one active licenses if there are licenses issued for individual units under the given property and
   * our property-to-license matching business logic for the specific customer allows matching multiple licenses (e.g.
   * associating unit-level licenses with the root unit).
   */
  activeLicenses: Array<ViolationLicenseReference>;
  /**
   * The history of violation state transitions.
   *
   * At most 100 most recent entries.
   */
  activity: Array<ViolationActivityEntry>;
  /**
   * Moment when this violation record has been created.
   *
   * This may be a first seen timestamp of a new violation, or the moment when previously closed violation was detected
   * again, resulting in the creation of this record.
   */
  created: Scalars['Timestamp']['output'];
  /**
   * Short human-friendly description of the violation.
   *
   * Some violations may have jurisdiction-specific phrasing. It's technically possible to have dynamically generated
   * messages which include property or license details.
   */
  description: Scalars['String']['output'];
  /** *Globally* unique stable opaque violation identifier. */
  id: Scalars['ID']['output'];
  /**
   * Moment when this violation record has been detected last time.
   *
   * For a new violation, created and lastSeen have the same value. For violation persisting over several violation engine
   * run, it would be the moment of the last run.
   */
  lastSeen: Scalars['Timestamp']['output'];
  /**
   * Moment when this violation records has been modified last time.
   *
   * As closed violations cannot be modified anymore, shows the close timestamp for them.
   */
  modified: Scalars['Timestamp']['output'];
  /**
   * Property associated with this violation (even if the violation is not *caused* by the property record).
   *
   * May be empty if we could not identify the property associated with the violation cause (e.g. listing without
   * identified property).
   */
  property?: Maybe<ViolationPropertyReference>;
  /**
   * We don't have formalized list of violations other than ad-hoc function names; "raw" means unverified strings as
   * opposed to enums.
   */
  rawType: Scalars['String']['output'];
  /**
   * License, property or listing (depending on the violation type) which *caused* this violation.
   *
   * For example:
   * - License for "TOT overdue" violation
   * - Listing for "no license listed" violation.
   */
  source: ViolationSourceReference;
  status: ViolationStatus;
  /** Collection of Deckard URLs associated with this violation. */
  urls: ViolationUrls;
};

/** Describes the history of violation status changes. */
export type ViolationActivityEntry = {
  __typename?: 'ViolationActivityEntry';
  /** Actor who caused this status change (e.g. violation engine or John Smith the operator). */
  actor: ViolationActor;
  /** Status the violation has been transitioned to as a result of this change. */
  destinationStatus: ViolationStatus;
  /** Instant it happened (non-TZ aware). */
  timestamp: Scalars['Timestamp']['output'];
};

export type ViolationActor = ViolationActorSystem | ViolationActorUser;

/** Describes the part of the system which caused a state transition of a violation. */
export type ViolationActorSystem = {
  __typename?: 'ViolationActorSystem';
  component?: Maybe<ViolationActorSystemComponent>;
};

export enum ViolationActorSystemComponent {
  /**
   * Forced future-compatibility placeholder. If a client receives a value it does not understand, it should be treated as
   * UNKNOWN.
   */
  Unknown = 'UNKNOWN',
  /**
   * Transition has been caused by violation engine (e.g. by detecting the violation or detecting that violation is no more
   * there).
   */
  ViolationEngine = 'VIOLATION_ENGINE'
}

/** Describes the user which caused a state transition of a violation. */
export type ViolationActorUser = {
  __typename?: 'ViolationActorUser';
  /**
   * User facing text, identifying the the user which triggered the change. No specific format guaranteed; the exact
   * presentation is selected by the backend. It may be, for example, "First Last" or "email@test.com".
   */
  displayName: Scalars['String']['output'];
};

/**
 * Relay edge for violation.
 *
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 */
export type ViolationEdge = {
  __typename?: 'ViolationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Violation>;
};

/** Association with a license causing the violation. */
export type ViolationLicenseReference = {
  __typename?: 'ViolationLicenseReference';
  /**
   * User-facing text identifying the license, for example a license number. No specific guaranteed format; backend
   * decides on the best presentation. Is not guaranteed to be unique.
   *
   * Intended to be used by UI to generate user-facing text.
   */
  displayName: Scalars['String']['output'];
  /** License number, as generated by the registration system and printed in the official documents. */
  licenseNumber: Scalars['String']['output'];
  /**
   * Internal opaque license reference. Format is not specified; it is not guaranteed to be a deckard ID, numeric license ID or
   * anything else specific. May be used in filters and mutations.
   *
   * Guaranteed to be unique within a customer scope. Not guaranteed to be globally unique. Guaranteed to be stable over
   * time.
   */
  licenseRef: Scalars['LicenseRef']['output'];
  /**
   * Unit, as provided by the registrant during the registration process.
   *
   * Empty string indicates no unit.
   */
  unit: Scalars['String']['output'];
};

/** Association with a listing causing the violation. */
export type ViolationListingReference = {
  __typename?: 'ViolationListingReference';
  /**
   * User-facing text identifying the listing, for example a listing number. No specific guaranteed format; backend
   * decides on the best presentation. Is not guaranteed to be unique.
   *
   * Intended to be used by UI to generate user-facing text.
   */
  displayName: Scalars['String']['output'];
  /**
   * Internal opaque listing ID. Format is not specified; it is not guaranteed to be a deckard ID.
   *
   * Guaranteed to be unique within a customer scope. Not guaranteed to be globally unique. Guaranteed to be stable over
   * time.
   */
  listingId: Scalars['ID']['output'];
  /** Original listing provider. */
  provider: ListingProvider;
};

/** Association with a property causing the violation. */
export type ViolationPropertyReference = {
  __typename?: 'ViolationPropertyReference';
  /**
   * APN / parcel number of the property.
   *
   * Unique within a customer, may be non-unique across different customers.
   */
  apn: Scalars['String']['output'];
  /**
   * Deckard ID for the
   * @deprecated No longer supported
   */
  deckardId: Scalars['ID']['output'];
  /**
   * User-facing text identifying the property, for example an address. No specific guaranteed format; backend
   * decides on the best presentation. Is not guaranteed to be unique.
   *
   * Intended to be used by UI to generate user-facing text.
   */
  displayName: Scalars['String']['output'];
  /**
   * Internal opaque license ID. Format is not specified; it is not guaranteed to be a deckard ID, numeric license ID or
   * anything else specific.
   *
   * Guaranteed to be unique within a customer scope. Not guaranteed to be globally unique. Guaranteed to be stable over
   * time.
   */
  propertyRef: Scalars['PropertyRef']['output'];
  /**
   * Unit, as associated in Cyborg or during the listing vetting process.
   *
   * Empty string indicates no unit.
   */
  unit: Scalars['String']['output'];
};

export type ViolationSourceReference = ViolationListingReference | ViolationPropertyReference;

/** Violation lifecycle. */
export enum ViolationStatus {
  /**
   * Violation has been opened (or re-opened) by the violations detection engine. Systems which deal with violations treat
   * this is "Action is required"; it may result in sending emails, physical letters, reminders etc.
   *
   * Possible transitions:
   * - UNDER_REVIEW (by operator, when starting work on violation);
   * - SUSPENDED (by operator, when starting work on violation and willing to pause side-effects of violation being open);
   * - CLOSED (by violation engine, if violation is not detected anymore);
   * - IGNORED (by operator, when violation is identified as false-positive or a known grandfathered exception).
   */
  Active = 'ACTIVE',
  /**
   * The violation engine detected that the violation is no more present.
   *
   * Closed violation records won't be reopened; violation engine will create a new violation (with a new distinct ID) of
   * the same type, if it's detected again.
   *
   * Possible transitions: N/A.
   */
  Closed = 'CLOSED',
  /**
   * This violation has been investigated and found to be a false-positive or a known grandfathered exception (for
   * example, historically licensed rental in the no-rentals zone).
   *
   * Possible transitions:
   * - ACTIVE (by operator, when a previously ignored violation is false negative and action is needed);
   * - SUSPENDED (set by operator, when the operator decides to suspend the violation for a period of time instead of
   *   completely ignore it. It indicates a mistake/change of mind);
   * - CLOSED (by operator; when fixing incorrectly ignored violation. Violation engine would pick up the possible
   *   violation on the next run).
   */
  Ignored = 'IGNORED',
  /**
   * An operator marked the violation as temporary suspended. Systems which deal with violations do not see this violation,
   * giving users a grace period to fix it before consequences start kicking in. The status will be reset to UNDER_REVIEW
   * automatically by the system after a globally configured time out.
   *
   * Possible transitions:
   * - ACTIVE (by operator, when violation is identified as positive and want to reactivate it ahead of the suspend period)
   * - UNDER_REVIEW (by operator, when willing to unpause normal violation handling mechanism);
   * - CLOSED (by violation engine, when violation is no more detected);
   * - IGNORED (by operator, when violation is identified as false-positive or a known grandfathered exception)
   */
  Suspended = 'SUSPENDED',
  /**
   * An operator started investigation of the violation and marked it to show as such in internal tools. From all other
   * perspectives, the violation is treated exactly the same as ACTIVE ones. For example, reminders should still be sent.
   *
   * Possible transitions:
   * - ACTIVE (by operator, when reversing a decision or confirming a violation, requiring corrective action);
   * - SUSPENDED (by operator, when willing to pause side-effects of violation being open);
   * - CLOSED (by violation engine, when violation is not detected anymore);
   * - IGNORED (by operator, when violation is identified as false-positive or a known grandfathered exception).
   */
  UnderReview = 'UNDER_REVIEW',
  /**
   * Forced future-compatibility placeholder. If a client receives a status it does not understand, it should be treated as
   * UNKNOWN.
   */
  Unknown = 'UNKNOWN'
}

/** Contains links to pages in Deckard related to this violation. */
export type ViolationUrls = {
  __typename?: 'ViolationUrls';
  /**
   * URL of the page where a jurisdiction operator can manage this violation.
   *
   * May change over time.
   */
  manage: Scalars['String']['output'];
};

/**
 * Relay connection for violations.
 *
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 */
export type ViolationsConnection = {
  __typename?: 'ViolationsConnection';
  /** Edges on the currently selected page. */
  edges: Array<ViolationEdge>;
  pageInfo: PageInfo;
};

export type ViolationsFilterInput = {
  /**
   * Optional property identifier; if provided, violations are limited to ones associated
   * to licenses and listings for ths property.
   */
  propertyDeckardId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * List of violation types eligible for inclusion in the result set.
   *
   * We don't have formalized list of violations other than ad-hoc function names; "raw" means unverified strings as
   * opposed to enums.
   *
   * Empty list indicates no filtering.
   */
  rawTypes: Array<Scalars['String']['input']>;
  /**
   * List of violation statuses eligible for inclusion in the result set.
   *
   * Empty list indicates no filtering.
   */
  statuses: Array<ViolationStatus>;
};

export type MarkActiveMutationVariables = Exact<{
  violationId: Scalars['ID']['input'];
}>;


export type MarkActiveMutation = { __typename?: 'Mutation', markActive: boolean };

export type MarkIgnoredMutationVariables = Exact<{
  violationId: Scalars['ID']['input'];
}>;


export type MarkIgnoredMutation = { __typename?: 'Mutation', markIgnored: boolean };

export type MarkSuspendedMutationVariables = Exact<{
  violationId: Scalars['ID']['input'];
}>;


export type MarkSuspendedMutation = { __typename?: 'Mutation', markSuspended: boolean };

export type MarkUnderReviewMutationVariables = Exact<{
  violationId: Scalars['ID']['input'];
}>;


export type MarkUnderReviewMutation = { __typename?: 'Mutation', markUnderReview: boolean };

export type ViolationsFragmentFragment = { __typename?: 'Region', violations: { __typename?: 'ViolationsConnection', edges: Array<{ __typename?: 'ViolationEdge', cursor?: string | null, node?: { __typename?: 'Violation', id: string, status: ViolationStatus, rawType: string, description: string, created: any, modified: any, lastSeen: any, source: { __typename?: 'ViolationListingReference', displayName: string, listingId: string, provider: ListingProvider } | { __typename?: 'ViolationPropertyReference', displayName: string, apn: string, unit: string, propertyRef: any }, property?: { __typename?: 'ViolationPropertyReference', propertyRef: any, displayName: string, apn: string, unit: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type GetViolationsQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  filter?: InputMaybe<ViolationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetViolationsQuery = { __typename?: 'Query', region?: { __typename?: 'Region', violations: { __typename?: 'ViolationsConnection', edges: Array<{ __typename?: 'ViolationEdge', cursor?: string | null, node?: { __typename?: 'Violation', id: string, status: ViolationStatus, rawType: string, description: string, created: any, modified: any, lastSeen: any, source: { __typename?: 'ViolationListingReference', displayName: string, listingId: string, provider: ListingProvider } | { __typename?: 'ViolationPropertyReference', displayName: string, apn: string, unit: string, propertyRef: any }, property?: { __typename?: 'ViolationPropertyReference', propertyRef: any, displayName: string, apn: string, unit: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } } | null };

export const ViolationsFragmentFragmentDoc = gql`
    fragment ViolationsFragment on Region {
  violations(filter: $filter, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        status
        rawType
        description
        source {
          ... on ViolationListingReference {
            displayName
            listingId
            provider
          }
          ... on ViolationPropertyReference {
            displayName
            apn
            unit
            propertyRef
          }
        }
        property {
          propertyRef
          displayName
          apn
          unit
        }
        created
        modified
        lastSeen
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;
export const MarkActiveDocument = gql`
    mutation MarkActive($violationId: ID!) {
  markActive(violationId: $violationId)
}
    `;
export type MarkActiveMutationFn = Apollo.MutationFunction<MarkActiveMutation, MarkActiveMutationVariables>;

/**
 * __useMarkActiveMutation__
 *
 * To run a mutation, you first call `useMarkActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markActiveMutation, { data, loading, error }] = useMarkActiveMutation({
 *   variables: {
 *      violationId: // value for 'violationId'
 *   },
 * });
 */
export function useMarkActiveMutation(baseOptions?: Apollo.MutationHookOptions<MarkActiveMutation, MarkActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkActiveMutation, MarkActiveMutationVariables>(MarkActiveDocument, options);
      }
export type MarkActiveMutationHookResult = ReturnType<typeof useMarkActiveMutation>;
export type MarkActiveMutationResult = Apollo.MutationResult<MarkActiveMutation>;
export type MarkActiveMutationOptions = Apollo.BaseMutationOptions<MarkActiveMutation, MarkActiveMutationVariables>;
export const MarkIgnoredDocument = gql`
    mutation MarkIgnored($violationId: ID!) {
  markIgnored(violationId: $violationId)
}
    `;
export type MarkIgnoredMutationFn = Apollo.MutationFunction<MarkIgnoredMutation, MarkIgnoredMutationVariables>;

/**
 * __useMarkIgnoredMutation__
 *
 * To run a mutation, you first call `useMarkIgnoredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkIgnoredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markIgnoredMutation, { data, loading, error }] = useMarkIgnoredMutation({
 *   variables: {
 *      violationId: // value for 'violationId'
 *   },
 * });
 */
export function useMarkIgnoredMutation(baseOptions?: Apollo.MutationHookOptions<MarkIgnoredMutation, MarkIgnoredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkIgnoredMutation, MarkIgnoredMutationVariables>(MarkIgnoredDocument, options);
      }
export type MarkIgnoredMutationHookResult = ReturnType<typeof useMarkIgnoredMutation>;
export type MarkIgnoredMutationResult = Apollo.MutationResult<MarkIgnoredMutation>;
export type MarkIgnoredMutationOptions = Apollo.BaseMutationOptions<MarkIgnoredMutation, MarkIgnoredMutationVariables>;
export const MarkSuspendedDocument = gql`
    mutation MarkSuspended($violationId: ID!) {
  markSuspended(violationId: $violationId)
}
    `;
export type MarkSuspendedMutationFn = Apollo.MutationFunction<MarkSuspendedMutation, MarkSuspendedMutationVariables>;

/**
 * __useMarkSuspendedMutation__
 *
 * To run a mutation, you first call `useMarkSuspendedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSuspendedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSuspendedMutation, { data, loading, error }] = useMarkSuspendedMutation({
 *   variables: {
 *      violationId: // value for 'violationId'
 *   },
 * });
 */
export function useMarkSuspendedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSuspendedMutation, MarkSuspendedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSuspendedMutation, MarkSuspendedMutationVariables>(MarkSuspendedDocument, options);
      }
export type MarkSuspendedMutationHookResult = ReturnType<typeof useMarkSuspendedMutation>;
export type MarkSuspendedMutationResult = Apollo.MutationResult<MarkSuspendedMutation>;
export type MarkSuspendedMutationOptions = Apollo.BaseMutationOptions<MarkSuspendedMutation, MarkSuspendedMutationVariables>;
export const MarkUnderReviewDocument = gql`
    mutation MarkUnderReview($violationId: ID!) {
  markUnderReview(violationId: $violationId)
}
    `;
export type MarkUnderReviewMutationFn = Apollo.MutationFunction<MarkUnderReviewMutation, MarkUnderReviewMutationVariables>;

/**
 * __useMarkUnderReviewMutation__
 *
 * To run a mutation, you first call `useMarkUnderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUnderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUnderReviewMutation, { data, loading, error }] = useMarkUnderReviewMutation({
 *   variables: {
 *      violationId: // value for 'violationId'
 *   },
 * });
 */
export function useMarkUnderReviewMutation(baseOptions?: Apollo.MutationHookOptions<MarkUnderReviewMutation, MarkUnderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUnderReviewMutation, MarkUnderReviewMutationVariables>(MarkUnderReviewDocument, options);
      }
export type MarkUnderReviewMutationHookResult = ReturnType<typeof useMarkUnderReviewMutation>;
export type MarkUnderReviewMutationResult = Apollo.MutationResult<MarkUnderReviewMutation>;
export type MarkUnderReviewMutationOptions = Apollo.BaseMutationOptions<MarkUnderReviewMutation, MarkUnderReviewMutationVariables>;
export const GetViolationsDocument = gql`
    query getViolations($regionId: ID!, $filter: ViolationsFilterInput, $first: Int, $after: String) {
  region(regionId: $regionId) {
    ...ViolationsFragment
  }
}
    ${ViolationsFragmentFragmentDoc}`;

/**
 * __useGetViolationsQuery__
 *
 * To run a query within a React component, call `useGetViolationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetViolationsQuery(baseOptions: Apollo.QueryHookOptions<GetViolationsQuery, GetViolationsQueryVariables> & ({ variables: GetViolationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViolationsQuery, GetViolationsQueryVariables>(GetViolationsDocument, options);
      }
export function useGetViolationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViolationsQuery, GetViolationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViolationsQuery, GetViolationsQueryVariables>(GetViolationsDocument, options);
        }
export function useGetViolationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetViolationsQuery, GetViolationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViolationsQuery, GetViolationsQueryVariables>(GetViolationsDocument, options);
        }
export type GetViolationsQueryHookResult = ReturnType<typeof useGetViolationsQuery>;
export type GetViolationsLazyQueryHookResult = ReturnType<typeof useGetViolationsLazyQuery>;
export type GetViolationsSuspenseQueryHookResult = ReturnType<typeof useGetViolationsSuspenseQuery>;
export type GetViolationsQueryResult = Apollo.QueryResult<GetViolationsQuery, GetViolationsQueryVariables>;